"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _reactRouter = require("react-router");

var _mmcVehicleCodeUtility = _interopRequireWildcard(require("@mmc-tools/mmc-vehicle-code-utility"));

var _commonRichText = require("@mmc/common-rich-text");

var _commonDialog = require("@mmc/common-dialog");

var _vehicleCompare = _interopRequireDefault(require("../styles/vehicle-compare.css"));

var _tableCompare = _interopRequireDefault(require("./table-compare.props/table-compare.defaultProps"));

var _tableCompare2 = require("./table-compare.props/table-compare.propTypes");

var _carSelectorContainer = _interopRequireDefault(require("./containers/car-selector-container"));

var _modelSelectorContainer = _interopRequireDefault(require("./containers/model-selector-container"));

var _comparisonTableContainer = _interopRequireDefault(require("./containers/comparison-table-container"));

var _actionTypes = require("../redux/actions/action-types");

var _vehicleCompareFooterContainer = _interopRequireDefault(require("./containers/vehicle-compare-footer-container"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ObfuscateVehicleCode = new _mmcVehicleCodeUtility["default"](_mmcVehicleCodeUtility.VEHICLES_MAP);
var getVehicleByCode = ObfuscateVehicleCode.getVehicleByCode;
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;

var VehiclesCompareSection = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(VehiclesCompareSection, _React$Component);

  VehiclesCompareSection.resourceType = function resourceType() {
    return 'VehiclesCompareSection_1_0_0';
  };

  function VehiclesCompareSection(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.numberOfColumns = 2;
    _this.closeDataLossOverlay = _this.closeDataLossOverlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.resetCarCompare = _this.resetCarCompare.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onRestartOverlay = _this.onRestartOverlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.closeRestartOverlay = _this.closeRestartOverlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateDimensions = _this.updateDimensions.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      resetModal: false
    };
    return _this;
  }

  var _proto = VehiclesCompareSection.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this,
        _componentData$carCom;

    if (typeof window !== 'undefined') {
      this.updateDimensions();
      var timeId = null;
      window.addEventListener('resize', function () {
        var delay = 100; // It clears the previous timeout

        clearTimeout(timeId); // It creates a new timeout to execute the function

        timeId = setTimeout(_this2.updateDimensions, delay);
      });
    } // @Todo fetch Vehicle Data from Redux


    var _this$props = this.props,
        dispatch = _this$props.dispatch,
        data = _this$props.data,
        defaultData = _this$props.defaultData;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var vehicles = componentData == null ? void 0 : (_componentData$carCom = componentData.carCompare) == null ? void 0 : _componentData$carCom.productTile; // const vehicles = productTile;

    dispatch({
      type: _actionTypes.VEHICLE_FULL_LIST,
      data: {
        vehicleList: vehicles
      }
    });
    var cloneVehicle = JSON.parse(JSON.stringify(vehicles));
    var vehicleTrimmed = this.getTrimmedVehicleList(cloneVehicle);
    dispatch({
      type: _actionTypes.VEHICLE_TRIM_LIST,
      data: {
        vehicleTrimList: vehicleTrimmed
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  };

  _proto.onRestartOverlay = function onRestartOverlay() {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'comparison_reset_CTA',
        comparison: {
          action: 'reset click'
        }
      });
    }

    this.setState({
      resetModal: true
    });
  };

  _proto.getVehicles = function getVehicles(componentData) {
    var currentPath = this.props.currentPath;
    var vehicles = componentData.carSelector.productTile;
    return vehicles.map(function (vehicle) {
      return _objectSpread(_objectSpread({}, vehicle), {}, {
        cta: {
          url: currentPath + "?vehicle=" + getVehicleByCode(vehicle.code) + "&year=" + vehicle.year
        }
      });
    });
  };

  _proto.getTrimmedVehicleList = function getTrimmedVehicleList(vehicleData) {
    if (vehicleData) {
      vehicleData.forEach(function (data) {
        // eslint-disable-next-line no-param-reassign
        data.models.forEach(function (model) {
          return delete model.detailedSpecifications;
        });
      });
    }

    return vehicleData;
  };

  _proto.getRichTextDescription = function getRichTextDescription(deviceType) {
    var theme = this.props.theme;
    return /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      html: deviceType,
      format: "inherit",
      theme: theme
    });
  };

  _proto.updateDimensions = function updateDimensions() {
    var width = typeof window !== 'undefined' && window.innerWidth || -1;
    var breakpointXS = 547;
    var breakpointSM = 659;
    var breakpointLG = 1180;

    if (width <= breakpointXS) {
      this.numberOfColumns = 2;
    } else if (width > breakpointXS && width <= breakpointSM) {
      this.numberOfColumns = 3;
    } else if (width > breakpointSM && width <= breakpointLG) {
      this.numberOfColumns = 4;
    } else if (width > breakpointLG) {
      this.numberOfColumns = 5;
    }

    this.forceUpdate();
  };

  _proto.closeRestartOverlay = function closeRestartOverlay() {
    this.setState({
      resetModal: false
    });
  };

  _proto.resetCarCompare = function resetCarCompare() {
    var dispatch = this.props.dispatch;
    dispatch({
      type: _actionTypes.VEHICLE_LIST_RESET
    });

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'comparison_reset_CTA',
        comparison: {
          action: 'reset confirmation'
        }
      });
    }

    this.closeRestartOverlay();
  };

  _proto.closeDataLossOverlay = function closeDataLossOverlay() {
    var dispatch = this.props.dispatch;
    dispatch({
      type: _actionTypes.VEHICLE_LIST_SHOW_HIDE,
      flag: {
        stage1: false,
        stage2: true,
        overlayDialog: false
      }
    });
  };

  _proto.renderSpecificCountText = function renderSpecificCountText(steps) {
    var numberOfColumns = this.numberOfColumns;

    if (numberOfColumns === 2) {
      var _steps$;

      return this.getRichTextDescription((_steps$ = steps[1]) == null ? void 0 : _steps$.mobileViewDescription);
    }

    if (numberOfColumns === 3) {
      var _steps$2;

      return this.getRichTextDescription((_steps$2 = steps[1]) == null ? void 0 : _steps$2.mobileLandscapeViewDescription);
    }

    if (numberOfColumns === 4) {
      var _steps$3;

      return this.getRichTextDescription((_steps$3 = steps[1]) == null ? void 0 : _steps$3.tabletViewDescription);
    }

    if (numberOfColumns === 5) {
      var _steps$4;

      return this.getRichTextDescription((_steps$4 = steps[1]) == null ? void 0 : _steps$4.description);
    }
  };

  _proto.render = function render() {
    var _componentData$carCom2,
        _data$steps$,
        _steps$5,
        _data$steps$2,
        _steps$6,
        _steps$7,
        _this3 = this;

    var _this$props2 = this.props,
        data = _this$props2.data,
        theme = _this$props2.theme,
        defaultData = _this$props2.defaultData,
        path = _this$props2.path,
        currentPath = _this$props2.currentPath,
        showVehicleList = _this$props2.showVehicleList;
    var resetModal = this.state.resetModal;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var vehicles = componentData == null ? void 0 : (_componentData$carCom2 = componentData.carCompare) == null ? void 0 : _componentData$carCom2.productTile; // const vehicles = productTile;

    var _componentData$carCom3 = componentData == null ? void 0 : componentData.carCompare,
        specificationGroup = _componentData$carCom3.specificationGroup,
        subSpecificationGroup = _componentData$carCom3.subSpecificationGroup;

    var collapseAllText = componentData.collapseAllText,
        expandAllText = componentData.expandAllText,
        steps = componentData.steps,
        addVehicleLabel = componentData.addVehicleLabel,
        changeVehicleLabel = componentData.changeVehicleLabel,
        deleteVehicleLabel = componentData.deleteVehicleLabel,
        restartActionDescription = componentData.restartActionDescription,
        restartActionLabel = componentData.restartActionLabel,
        restartActionMainLabel = componentData.restartActionMainLabel,
        restartCancelLabel = componentData.restartCancelLabel,
        restartConfirmationLabel = componentData.restartConfirmationLabel;
    var numberOfColumns = this.numberOfColumns;
    var argsRestart = {
      links: [{
        ctaType: 'button',
        label: restartConfirmationLabel,
        priority: 'critical'
      }, {
        ctaType: 'button',
        label: restartCancelLabel,
        priority: 'low'
      }],
      overlayCopy: {
        text: restartActionDescription,
        title: restartActionLabel
      }
    };
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + (showVehicleList.stage1 ? '' : _vehicleCompare["default"].hidden)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['center-xs'] + " " + theme['container-fluid'] + " " + _vehicleCompare["default"].headerVehicleCompare
    }, /*#__PURE__*/_react["default"].createElement("h1", {
      className: theme.mb6
    }, data == null ? void 0 : (_data$steps$ = data.steps[0]) == null ? void 0 : _data$steps$.name), /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.BodyCopyMed
    }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      html: (_steps$5 = steps[0]) == null ? void 0 : _steps$5.description,
      format: "inherit",
      theme: theme
    }))), /*#__PURE__*/_react["default"].createElement(_carSelectorContainer["default"], {
      vehicles: vehicles,
      theme: theme
    })), /*#__PURE__*/_react["default"].createElement(_commonDialog.CommonDialog, {
      isOpen: showVehicleList.overlayDialog,
      theme: theme,
      closeEvent: this.closeDataLossOverlay
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['center-xs']
    }, /*#__PURE__*/_react["default"].createElement("h1", {
      className: theme.mb6 + " " + _vehicleCompare["default"].dialogHeading
    }, data == null ? void 0 : (_data$steps$2 = data.steps[0]) == null ? void 0 : _data$steps$2.name), /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.BodyCopyMed
    }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      html: (_steps$6 = steps[0]) == null ? void 0 : _steps$6.description,
      format: "inherit",
      theme: theme
    }))), /*#__PURE__*/_react["default"].createElement(_carSelectorContainer["default"], {
      vehicles: vehicles,
      theme: theme
    })), /*#__PURE__*/_react["default"].createElement(_commonDialog.CommonDialog, {
      data: argsRestart,
      linkEvents: [this.resetCarCompare, this.closeRestartOverlay],
      theme: theme,
      isOpen: resetModal,
      closeEvent: this.closeRestartOverlay
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _vehicleCompare["default"].noPadding + " " + (showVehicleList.stage2 ? '' : _vehicleCompare["default"].hidden)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['center-xs'] + " " + theme['container-fluid'] + " " + _vehicleCompare["default"].headerVehicleCompare
    }, /*#__PURE__*/_react["default"].createElement("h1", {
      className: theme.mb6
    }, (_steps$7 = steps[1]) == null ? void 0 : _steps$7.name), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.BodyCopyMed + " " + _vehicleCompare["default"].headerDescription
    }, this.renderSpecificCountText(steps)), /*#__PURE__*/_react["default"].createElement("button", {
      className: theme.low + " " + theme.marginTop10,
      type: "button",
      onClick: function onClick() {
        _this3.onRestartOverlay();
      }
    }, restartActionMainLabel)), /*#__PURE__*/_react["default"].createElement(_modelSelectorContainer["default"], {
      theme: theme,
      path: path,
      currentPath: currentPath,
      numberOfColumns: numberOfColumns,
      addVehicleLabel: addVehicleLabel,
      changeVehicleLabel: changeVehicleLabel,
      deleteVehicleLabel: deleteVehicleLabel
    }), /*#__PURE__*/_react["default"].createElement(_comparisonTableContainer["default"], {
      theme: theme,
      specificationGroups: specificationGroup,
      subSpecificationGroups: subSpecificationGroup,
      numberOfColumns: numberOfColumns,
      collapseAllText: collapseAllText,
      expandAllText: expandAllText
    }), /*#__PURE__*/_react["default"].createElement(_vehicleCompareFooterContainer["default"], {
      theme: theme,
      path: path,
      currentPath: currentPath,
      numberOfColumns: numberOfColumns
    })));
  };

  return VehiclesCompareSection;
}(_react["default"].Component);

VehiclesCompareSection.displayName = 'VehiclesCompareSection';
VehiclesCompareSection.defaultProps = {
  data: _tableCompare["default"],
  defaultData: _tableCompare["default"]
};

var _default = (0, _reactRouter.withRouter)(VehiclesCompareSection);

exports["default"] = _default;